(ns practitest.frontend.tests.events
  (:require [ajax.core :as ajax]
            [clojure.string :as str]
            [practitest.frontend.common-entities.events :as common-events]
            [practitest.frontend.common-entities.metadata :refer [entities-metadata]]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.common-entities :as common-entities]
            [practitest.frontend.components.grid.subs :as grid.subs]
            [practitest.frontend.components.notifications :as notifications]
            [practitest.frontend.events :as events]
            [practitest.frontend.issue.bugtracker :as bugtracker]
            [practitest.frontend.routing.backend-routes :as broutes]
            [practitest.frontend.subs :as subs]
            [practitest.frontend.forms3.entity-form :as entity-form]
            [practitest.frontend.tests.test-form.smartfox-modal :as smartfox]
            [re-frame.core :as re-frame]))

(def tests-index-state-key (:test subs/index-grid-keys))

(defn- get-current-view [db entity state-key]
  (let [current-tab (get-in db [:entity entity state-key :current-tab])
        current-filter (get-in db [:entity entity state-key :current-filter-selected])
        current-folder (get-in db [:entity entity state-key :current-folder-selected])]
    (if (= current-tab "folders")
      (assoc current-folder :type :folder)
      (assoc current-filter :type :filter))))

(defn link-tests-to-testsets [{db :db} [_ current-entity state-key selected-testsets]]
  (let [selection (grid.subs/get-selection db [current-entity tests-index-state-key])
        current-view (get-current-view db current-entity tests-index-state-key)
        test-ids (common-entities/prepare-full-selection-ids selection current-view)]
    {:db (update db :progress conj ::link-tests-to-testsets)
     :http-xhrio
     {:method          :get
      :uri             (broutes/get-url "suites#link_tests_to_testsets"
                                        {:p_id (subs/get-current-project-id db)})
      :format          :url
      :vec-strategy    :rails
      :params          {:tests test-ids
                        :suites (str/join "," selected-testsets)}
      :response-format (ajax/json-response-format {:keywords? true})
      :on-success      [::on-link-tests-success state-key]
      :on-failure      [::events/api-error ::link-tests-to-testsets
                        {:message (get-translation "test.notify.link-testset-error"
                                                   "Error linking Tests to Test Sets")}]}}))

(defn on-linked-tests-success [{db :db} [_ state-key response]]
  {:db         db
   :dispatch-n [[::notifications/success2
                 (str
                   (get-translation "tests.notification.linked-to-testsets-success" "Successfully added tests to TestSets")
                   ": "
                   (str (str/join "," (:valid_suites response))))]
                [::common-events/toggle-link-entities-modal (:current-entity db) state-key]]})

(re-frame/reg-event-fx
  ::link-tests-to-testsets
  link-tests-to-testsets)

(re-frame/reg-event-fx
  ::on-link-tests-success
  on-linked-tests-success)

;; Copies field values from entity to form state (to init new test values)
(defn- init-test
  [db test requirement-id]
  (-> db
      (update-in
        [:form-states2 :test-main :fields]
        (fn [fields]
          (reduce-kv
            (fn [fields field value]
              (if (not (str/blank? value))
                (update fields field assoc
                        :value value
                        :dirty? (not= value (get-in fields [field :value])))
                fields))
            fields
            test)))
      (cond-> requirement-id
              (update-in [:form-states2 :test-main :linked_requirement_ids]
                         #(conj (or % #{}) (js/parseInt requirement-id))))))

(re-frame/reg-event-fx
  ::requirement-linked
  (fn [{db :db} [_ requirement-id generate-steps? response]]
    (let [updated-db (-> db
                         (update :progress disj ::link-requirement)
                         (assoc-in [:form-states2 :test-main :from-bugtrecker :details] response)
                         (assoc-in [:entity :test :traceability] (:traceability response))
                   ;; Copy field values to form (only on new form)
                         (init-test (:entity response) requirement-id))]
      (if generate-steps?
        {:db updated-db
         :dispatch [::smartfox/generate-steps]}
        {:db updated-db}))))

(re-frame/reg-event-fx
  ::link-requirement-error
  (fn [{:keys [db]} [_ error]]
    {:db (update db :progress disj ::link-requirement)
     :dispatch [::events/api-error ::link-requirement-error
                {:message (get-translation "test.notify.error-linking-requierement" "Error linking Requirements to Test")}] }))

(re-frame/reg-event-fx
  ::link-requirement
  (fn [{db :db} [_ requirement-id generate-steps?]]
    (let [bugtracker (bugtracker/bugtracker-type @(re-frame/subscribe [::subs/current-project]))]
      {:db (update db :progress conj ::link-requirement)
       :http-xhrio
       {:method          :get
        :uri             (broutes/get-url "qtest_designs#create_test_from_requirement"
                                          {:p_id (subs/get-current-project-id db)
                                           :id requirement-id})
        :params          {:bugtracker bugtracker}
        :format          (ajax/json-request-format)
        :response-format (ajax/json-response-format {:keywords? true})
        :on-success      [::requirement-linked requirement-id generate-steps?]
        :on-failure      [::link-requirement-error]}})))

(re-frame/reg-event-fx
  ::got-et-details
  (fn [{:keys [db]} [_ response]]
    {:db (-> db
             (update :progress disj ::fetch-et-details)
             (init-test (:entity response) nil))
     ;; Fully qualified to avoid circular dependency
     :dispatch [:practitest.frontend.tests.test-form.test-steps/add-steps-from-et response]}))

(re-frame/reg-event-fx
  ::et-details-error
  (fn [{:keys [db]} [_ error]]
    {:db (update db :progress disj ::fetch-et-details)
     :dispatch [::events/api-error ::fetch-et-details
                {:message (get-translation "test.notify.error-creating-from-et" "Error creating Test from ET")}]}))

(re-frame/reg-event-fx
  ::fetch-et-details
  (fn [{db :db} [_ et-id]]
    {:db (update db :progress conj ::fetch-et-details)
     :http-xhrio
     {:method          :get
      :uri             (broutes/get-url "qtest_designs#new_from_et"
                                        {:p_id (subs/get-current-project-id db)})
      :params          {:et_id et-id}
      :format          (ajax/json-request-format)
      :response-format (ajax/json-response-format {:keywords? true})
      :on-success      [::got-et-details]
      :on-failure      [::et-details-error]}}))

(re-frame/reg-event-fx
  ::update-from-parent-data-success
  (fn [{:keys [db]} [_ response]]
    (if (:versioned response)
      ;; Handle versioned response - navigate to new version
      (let [new-id (:new_id response)
            entity-type :test
            routes (get-in entities-metadata [entity-type :routes])
            edit-route (:edit routes)
            entity-key (:entity-key routes)]
        {:db (update db :progress disj ::update-from-parent-data)
         :dispatch-n [[::notifications/success2
                       (get-translation "test.notify.updating-from-parent-success"
                                        "Test updated from parent successfully")]
                      [::common-events/navigate-to-new-version-and-refresh new-id edit-route entity-key]]})
      ;; Non-versioned response
      (let [fetch-options {:form-id :test-main
                           :entity-type :test
                           :entity-id (subs/get-current-entity-id db :test)
                           :project-id (subs/get-current-project-id db)
                           :new? false}]
        {:db (update db :progress disj ::update-from-parent-data)
         :dispatch-n [[::entity-form/fetch-entity fetch-options]
                      [::notifications/success2
                       (get-translation "test.notify.updating-from-parent-success"
                                        "Test updated from parent successfully")]]}))))

(re-frame/reg-event-fx
  ::update-from-parent-data-failure
  (fn [{:keys [db]} [_ error]]
    {:db (update db :progress disj ::update-from-parent-data)
     :dispatch [::events/api-error ::update-from-parent-data
                {:message (get-translation "test.notify.error-updating-from-parent" "Error updating from parent test data")}]}))

(re-frame/reg-event-fx
  ::update-from-parent-data
  (fn [{:keys [db]} [_ update-url]]
    {:db         (update db :progress conj ::update-from-parent-data)
     :http-xhrio {:method          :post
                  :uri             update-url
                  :params          {}
                  :format          (ajax/json-request-format)
                  :response-format (ajax/json-response-format {:keywords? true})
                  :on-success      [::update-from-parent-data-success]
                  :on-failure      [::update-from-parent-data-failure]}}))

(re-frame/reg-event-fx
  ::fetch-steps-params
  (fn [{:keys [db]} _]
    {:db (update db :progress conj ::fetch-steps-params)
     :http-xhrio
     {:method          :get
      :uri             (broutes/get-url "projects#step_params"
                                        {:project_id (subs/get-current-project-id db)})
      :format          (ajax/json-request-format)
      :response-format (ajax/json-response-format {:keywords? true})
      :on-success      [::fetch-step-params-success]
      :on-failure      [::fetch-step-params-failure]}}))

(re-frame/reg-event-fx
  ::create-step-param
  (fn [{:keys [db]} [_ param-name]]
    {:db (update db :progress conj ::create-step-param)
     :http-xhrio {:method          :get
                  :uri             (broutes/get-url
                                     "projects#create_step_param"
                                     {:project_id (subs/get-current-project-id db)})
                  :params          {:name param-name}
                  :format          (ajax/json-request-format)
                  :response-format (ajax/json-response-format {:keywords? true})
                  :on-success      [::create-step-param-success]
                  :on-failure      [::create-step-params-failure]}}))

(re-frame/reg-event-db
  ::fetch-step-params-success
  (fn [db [_ step-params]]
    (-> db
        (update :progress disj ::fetch-steps-params)
        (assoc-in [:form-states2 :test-steps :steps-params]
                  step-params))))

(re-frame/reg-event-fx
  ::fetch-step-params-failure
  (fn [{:keys [db]} [_ error]]
    {:db (update db :progress disj ::fetch-steps-params)
     :dispatch
     [::events/api-error
      ::fetch-steps-params
      {:message (get-translation
                  "test.step.param.fetching.error"
                  "Error fetching step parameters")}]}))

(re-frame/reg-event-fx
  ::create-step-param-success
  (fn [{:keys [db]} [_ {:keys [success error_msg] :as resp}]]
    (let [success? success]
      {:db (update db :progress disj ::create-step-param)
       :dispatch-n
       (if success?
         [[::fetch-steps-params]
          [::notifications/success2
           (get-translation
             "test.step.param.create.success"
             "Parameter was successfully created")
           {:auto-close notifications/auto-close-success-timeout}]]
         [[::notifications/error2
           error_msg
           {:auto-close 5000}]])})))

(re-frame/reg-event-fx
  ::create-step-params-failure
  (fn [{:keys [db]} [_ error]]
    {:db (update db :progress disj ::create-step-param)
     :dispatch
     [::events/api-error
      ::create-step-param
      {:message (get-translation
                  "test.step.param.fetching.error"
                  "Error creating step parameters")}]}))
